import clsx from "clsx";
import blendStyles from "../WordBlendFlow.module.css";
import styles from "./ClusterSpreadCvc.module.css";

/**
 * Lesson-driven tap row: layouts clusterEqual | clusterBridge | clusterOnset | mergeWide.
 */
export function InteractiveTapStepRow({ step, onTapPayload, plainUi = false }) {
  if (!step?.chunks?.length) return null;

  const btnClass = plainUi
    ? blendStyles.spacedPlainLetter
    : clsx(blendStyles.chunk, blendStyles.chunkBtn);

  const rowClass = (variant) =>
    clsx(
      blendStyles.chunksRow,
      plainUi ? blendStyles.spread : variant
    );

  const letterPill = (ch, suffix) => (
    <button
      key={`${suffix}-${ch}`}
      type="button"
      className={btnClass}
      onClick={() => onTapPayload({ kind: "letter", value: ch })}
    >
      {ch}
    </button>
  );

  const chunkPill = (ch, suffix) => (
    <button
      key={`${suffix}-${ch}`}
      type="button"
      className={btnClass}
      onClick={() => onTapPayload({ kind: "chunk", value: ch })}
    >
      {ch}
    </button>
  );

  switch (step.layout) {
    case "clusterEqual":
      return (
        <div className={rowClass(styles.stageEqual)}>
          {step.chunks.map((ch, i) => letterPill(ch, `eq-${i}`))}
        </div>
      );
    case "clusterBridge":
      return (
        <div className={rowClass(styles.stageBridge)}>
          {step.chunks.map((ch, i) => letterPill(ch, `br-${i}`))}
        </div>
      );
    case "clusterOnset": {
      const [first, onsetLabel] = step.chunks;
      const letterTarget = step.target;
      return (
        <div className={rowClass(styles.stageFinal)}>
          {letterPill(first, "on0")}
          <button
            key={`on-onset-${onsetLabel}`}
            type="button"
            className={clsx(btnClass, !plainUi && styles.onsetCircle)}
            onClick={() => onTapPayload({ kind: "letter", value: letterTarget })}
          >
            {onsetLabel}
          </button>
        </div>
      );
    }
    case "mergeWide":
      return (
        <div className={rowClass(styles.mergeWide)}>
          {step.chunks.map((ch, i) => chunkPill(ch, `mw-${i}`))}
        </div>
      );
    default:
      return null;
  }
}
